import React from 'react';
import { NavDropdown, Button, DropdownButton, ButtonGroup, Dropdown, Nav, Navbar, Container } from 'react-bootstrap';



function NavBar() {

	const Bucket = "https://d1en57qlwrlmqu.cloudfront.net/P450/20260618";

	return (
		<div style={{ background: "#5B9BD5" }}>
			<Navbar variant="dark" style={{ fontSize: "20px" }}>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="me-auto custom-nav">
						<Nav.Link href="/">Home</Nav.Link>
						<Nav.Link href="/tables">Known P450s</Nav.Link>
						<NavDropdown  title="Tools" id="basic-nav-dropdown">
							{/* <NavDropdown.Item style={{ fontSize: "18px" }} href="/submit">Submit</NavDropdown.Item>
							<NavDropdown.Divider /> */}
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/blast_submit"><b>P450 Blast</b></NavDropdown.Item>
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/blast_results">Results</NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/substrate"><b>Searching Substrate Molecules</b></NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/esp"><b>P450-Substrate Reactivity (Seq-P450)</b></NavDropdown.Item>
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/esp-results">Results</NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/af_submit"><b>P450 Boltz</b></NavDropdown.Item>
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/results">Results</NavDropdown.Item>
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/queue">Queue</NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href=" https://github.com/JiangLab2020/P450Diffusion" target="_blank" rel="noopener noreferrer"><b>P450Diffusion</b></NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href="https://github.com/JiangLab2020/DM-P450" target="_blank" rel="noopener noreferrer"><b>DM-P450</b></NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href="/submission" target="_blank" rel="noopener noreferrer"><b>P450 Enzyme Submission</b></NavDropdown.Item>
						</NavDropdown>
						<Nav.Link href="/contact">Contact</Nav.Link>
						{/* <Nav.Link href="/download">Download</Nav.Link> */}
						<NavDropdown title="Download" id="basic-nav-dropdown">
							<NavDropdown.Item style={{ fontSize: "18px" }} href={`${Bucket}/P450_All_v2_60.zip`}>P450_All_v2_60</NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href={`${Bucket}/P450_All_v2_90.zip`}>P450_All_v2_90</NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item style={{ fontSize: "18px" }} href={`${Bucket}/P450_All_v2_100.zip`}>P450_All_v2_100</NavDropdown.Item>
						</NavDropdown>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		</div>
	);

}






export default NavBar;